import Card from "@/components/Card/index";
import Grid from "@/components/Grid";
import { usePaletteQuery } from "@/hooks";
import { GRID_PAGE_LIMIT } from "@/lib/constants";
import { useMemo } from "react";

export default function PaletteGrid({
  id,
  limit = GRID_PAGE_LIMIT,
  maxLength,
  loadMore = true,
  ...props
}) {
  if (maxLength && limit > maxLength) {
    limit = maxLength;
  }
  const { data, ...result } = usePaletteQuery({
    variables: { id, offset: 0, limit },
    nextFetchPolicy: "cache-first",
  });
  const palette = data?.palette;
  const paletteObjects = data?.paletteObjects;
  const items = useMemo(() => {
    if (paletteObjects) {
      return {
        data: paletteObjects.data.map((obj) => obj.meta || obj.advertising),
        pageInfo: paletteObjects.pageInfo,
      };
    } else {
      return null;
    }
  }, [paletteObjects]);

  return (
    <Grid
      header={{ text: palette?.header, main: true }}
      viewTypeClassName="grid"
      itemComponent={Card}
      items={items}
      {...result}
      {...{ limit, maxLength, loadMore }}
      {...props}
    />
  );
}
